import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReceivingHoursAlertBannerComponent } from "./receiving-hours-alert-banner.component";



@NgModule({
  declarations: [ReceivingHoursAlertBannerComponent],
  imports: [
    CommonModule
  ],
  exports: [ReceivingHoursAlertBannerComponent]
})
export class ReceivingHoursAlertBannerModule { }
